import React, {useCallback, useEffect} from 'react';
import {SnackbarProps} from './types';
import {Layout} from '../layout/';
import {Text} from '../text';
import {SnackbarStyleMap} from './styles';
import {Icon} from '..';
import {setTimeout, clearTimeout} from 'timers';

export const Snackbar: React.FC<SnackbarProps> = ({
  id,
  kind = 'Default',
  solo = 'Yes',
  hasCloseButton = false,
  content,
  actionTitle,
  duration,
  onDismiss,
  onAction,
}) => {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    if (duration) {
      timer = setTimeout(() => {
        timer = undefined;
        onDismiss && onDismiss(id);
      }, duration);
    }
    return () => timer && clearTimeout(timer);
  }, [duration, id, onDismiss]);

  const handleAction = useCallback(() => {
    onAction && onAction(id);
  }, [id, onAction]);

  const handleDismiss = useCallback(() => {
    onDismiss && onDismiss(id);
  }, [id, onDismiss]);

  return (
    <Layout
      horizontal
      minHeight={56}
      flex={1}
      paddingLeft="20"
      paddingRight="12"
      align="center"
      justify="space-between"
      {...SnackbarStyleMap[kind][solo]}>
      <Layout paddingVertical="18">
        <Text
          variant={'inline_14_default'}
          textColor={'content_mono_inverse_primary'}>
          {content}
        </Text>
      </Layout>
      {hasCloseButton ? (
        <Layout
          onPress={handleDismiss}
          hover
          align="center"
          backgroundColor={SnackbarStyleMap[kind][solo].backgroundColor}
          paddingHorizontal="6"
          paddingVertical="6"
          borderRadius="4">
          <Icon name="close" inverse />
        </Layout>
      ) : actionTitle ? (
        <Layout
          onPress={handleAction}
          hover
          align="center"
          backgroundColor={SnackbarStyleMap[kind][solo].backgroundColor}
          paddingHorizontal="6"
          paddingVertical="6"
          borderRadius="4">
          <Text
            textColor="content_mono_inverse_primary"
            variant="inline_14_emphasis">
            {actionTitle}
          </Text>
        </Layout>
      ) : null}
    </Layout>
  );
};
